import styled, { css } from 'styled-components';
import Icon from '../../Icon';
import { media } from '../../themes/theme';
const primaryStyle = css `
  margin-right: 0.5rem;
  width: 1.25rem;
  height: 1.25rem;
`;
const startStyle = css `
  margin-right: 0.5rem;
  width: 0.875rem;
  height: 0.875rem;

  ${media.tablet `
    width: 1.125rem;
    height: 1.125rem;
  `}
`;
const endStyle = css `
  margin-left: 0.5rem;
  width: 0.875rem;
  height: 0.875rem;

  ${media.tablet `
    width: 1.125rem;
    height: 1.125rem;
  `}
`;
const backLinkStyle = css `
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.5rem;

  ${media.tablet `
    width: 1.125rem;
    height: 1.125rem;
  `}
`;
export default styled(Icon) `
  ${props => (props.style === 'primary' || 'secondary') && primaryStyle}
  ${props => props.start && startStyle}
  ${props => props.end && endStyle}
  ${props => props.backLink && backLinkStyle}
`;
